export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyBy2ZVhEDFzsON2vUDt_PGfawQJlBEE77w",
    authDomain: "brainwatch-14583.firebaseapp.com",
    databaseURL: "https://brainwatch-14583-default-rtdb.firebaseio.com",
    projectId: "brainwatch-14583",
    storageBucket: "brainwatch-14583.appspot.com",
    messagingSenderId: "213448911525",
    appId: "1:213448911525:web:d340f0cc91b7bbf042bb4c",
    measurementId: "G-QX9XMSWFP9"
  },
  baseUrl: "http://localhost:8080"
};
